<template>
  <b-container fluid>
    <backlink />
    <h1>Libellés de frais</h1>
    <p class="text-muted">Suggestions proposées à la saisie d&#39;une ligne de frais, avec leurs valeurs par défaut. La saisie libre reste possible : un libellé absent d&#39;ici s&#39;utilise tel quel.</p>
    <AdminTable :config="config"></AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTable";
import config from "./config";

export default {
  name: "FeeLabelList",
  components: {
    AdminTable,
  },
  data() {
    return {
      config: config,
    };
  },
  created() {
    // Vocabulaires servis par l'API : ils alimentent les libellés de la liste et les
    // listes déroulantes du formulaire.
    this.$store.dispatch("fee_label/getOptions");
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FeeLabel/FeeLabelList.vue